export const REGION_STORAGE_KEY = "ventoron-region"

export const regions = {
  UK: {
    code: "UK",
    country: "United Kingdom",
    phone: "+44 730 1494637",
    phoneHref: "tel:+447301494637",
    address: ["513 Cheam Sutton London Road"],
    email: "hello@ventorontech.com",
    infoEmail: "info@ventorontech.com",
  },
  AU: {
    code: "AU",
    country: "Australia",
    phone: "+61 450 470 843",
    phoneHref: "tel:+61450470843",
    address: ["136 Carlingford Road", "Epping NSW 2121", "Australia"],
    email: "hello@ventorontech.com",
    infoEmail: "info@ventorontech.com",
  },
}

export const getStoredRegion = () => {
  if (typeof window === "undefined") return null
  const storedRegion = window.localStorage.getItem(REGION_STORAGE_KEY)
  return regions[storedRegion] ? storedRegion : null
}

export const detectRegion = () => {
  if (typeof window === "undefined") return "UK"

  const developmentOverride = window.__VENTORON_REGION__
  if (developmentOverride === "AU" || developmentOverride === "UK") {
    return developmentOverride
  }

  const deploymentCountry = window.__VENTORON_COUNTRY__
  return deploymentCountry?.toUpperCase() === "AU" ? "AU" : "UK"
}
